import React, { useState, useEffect } from "react";

import { Row, Col, FormControl, Checkbox, Grid } from "react-bootstrap";

import { useMultiFilterContext } from "contexts/MultiFilterContext";
import { useEditCoachPoolContext } from "contexts/EditCoachPoolContext";

export default function FilterItem({ item, size }) {
  const { dispatch, actions, state } = useMultiFilterContext();
  const {
    dispatch: dispatchEditCoachPool,
    actions: actionsEditCoachPool,
    state: stateEditCoachPool,
  } = useEditCoachPoolContext();

  const setCheckState = (e) => {
    actions.setChecked(
      dispatch,
      item.subcategory,
      item.value,
      e.target.checked
    );
    actionsEditCoachPool.clearSelectedAll(dispatchEditCoachPool);
  };

  return (
    <Col md={size}>
      <Checkbox
        checked={state.selected[item.subcategory].includes(item.value) || false}
        onChange={setCheckState}
      >
        {item.label}
      </Checkbox>
    </Col>
  );
}
